import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import useSnackbar from 'hooks/useSnackbar';
import { Checkbox, Chip, FormControlLabel, FormGroup, Stack } from '@mui/material';
import { makeCSV, downloadCSV } from 'utils/export';
import { downloadFile } from 'utils/file';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        minWidth: 540
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1)
    }
}));

export default function ExportColumnData({
    handleDownload,
    type = 'text',
    fileName,
    handleClose,
    exportData,
    formattedColumns,
    hideButton,
    betaBtn = false,
    sx,
    sxBtn
}) {
    if (!formattedColumns && exportData) {
        console.log({ exportData });
        const blob = exportData?.blob;
        const fileName = exportData?.fileName;
        downloadFile(blob, fileName);
        handleClose();
    }

    const [reportData, setReportData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);

    const convertStructure = () => {
        let fomattedData = [];
        if (type === 'text') {
            const data = exportData.data.split('\n').map((item) => item.split(','));
            const cols = data[0];

            const rows = data.slice(1);

            fomattedData = rows.map((item) => {
                const obj = {};
                cols.forEach((col, i) => {
                    obj[col] = item[i];
                });
                return obj;
            });
        } else if (type === 'json') {
            fomattedData = exportData;
        }

        setColumns(Object.keys(formattedColumns));
        setSelectedColumns(Object.keys(formattedColumns));
        setReportData(fomattedData);
    };

    useEffect(() => {
        if (formattedColumns && exportData) {
            convertStructure();
        }
    }, [exportData]);

    const handleExport = () => {
        let downloadFileName = '';
        if (!fileName) {
            const file = Object.fromEntries(exportData.headers);
            downloadFileName = file['x-suggested-filename'];
        } else if (type === 'json') {
            downloadFileName = fileName;
        }
        const filteredData = reportData.map((item) => {
            const obj = {};
            selectedColumns.forEach((col) => {
                obj[formattedColumns[col]] = item[col];
            });
            return obj;
        });

        const csvdata = makeCSV(filteredData);
        downloadCSV(csvdata, downloadFileName);
        handleClose();
    };

    const [selectAll, setSelectAll] = useState(true);

    useEffect(() => {
        if (selectedColumns.length === columns.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }
    }, [selectedColumns]);

    return (
        <>
            {!hideButton && betaBtn ? (
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{
                        alignItems: "center",
                        justifyContent: "flex-end",
                        position: 'relative',
                        display: 'inline-block',
                        margin: '5px 22px',
                        ...sx
                    }}>
                    <Button
                        onClick={handleDownload}
                        fullWidth
                        disableElevation
                        variant="contained"
                        sx={{
                            minHeight: 50,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '200px',
                            ...sxBtn
                        }}
                    >
                        Export CSV
                    </Button>
                    <Chip
                        label="Beta"
                        variant="outlined"
                        size="small"
                        color="secondary"
                        sx={{
                            textTransform: 'uppercase',
                            alignSelf: 'flex-start',
                            fontSize: '10px',
                            height: '20px',
                            padding: '0 4px',
                            marginLeft: '4px !important',
                            backgroundColor: '#ffffff',
                            position: 'absolute',
                            top: '0px',
                            right: '7px',
                            transform: 'translate(50%, -50%)'
                        }}
                    />
                </Stack>
            ) : (
                !hideButton &&
                !betaBtn && (
                    <Button onClick={handleDownload} variant="contained" sx={{ minHeight: 50 }}>
                        Export CSV
                    </Button>
                )
            )}
            {formattedColumns && (
                <BootstrapDialog open={Boolean(exportData)} onClose={handleClose}>
                    <DialogTitle sx={{ m: 0, p: 2 }}>Select Export Properties</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500]
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent dividers>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={selectAll}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedColumns(columns);
                                            } else {
                                                setSelectedColumns([]);
                                            }
                                        }}
                                    />
                                }
                                label="Select All"
                            />
                            {columns.map((item) => (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedColumns.includes(item)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedColumns([...selectedColumns, item]);
                                                } else {
                                                    setSelectedColumns(selectedColumns.filter((col) => col !== item));
                                                }
                                            }}
                                        />
                                    }
                                    label={formattedColumns[item]}
                                />
                            ))}
                        </FormGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleExport}>
                            Export
                        </Button>
                    </DialogActions>
                </BootstrapDialog>
            )}
        </>
    );
}
